import React from 'react';
import { TextField } from '@mui/material';
import formStyles from '../../../form/Form.module.css';
import Input from '../../../form/Input';

const medidas = [
    { name: 'pocoProfundidadeMetros', label: 'Profundidade (m)', title: 'Profundidade total do poço em metros, conforme cadastro técnico ou documento conferido.' },
    { name: 'pocoDiametroPolegadas', label: 'Diâmetro (polegadas)', title: 'Diâmetro do poço em polegadas. Não informar em metros nem usar o diâmetro da tubulação sem conferir a referência técnica.' },
];

const PocoSection = ({ bem = {}, actions }) => {
    const change = actions.draft.change;

    // Mantém DECIMAL como string; o handler de Bens recebe o mesmo contrato dos demais campos.
    const changeMedida = (event) => {
        const { name, value } = event.target;
        const decimal = value.replace(',', '.');
        if (decimal !== '' && !/^\d+(?:\.\d{0,3})?$/.test(decimal)) return;
        change({ target: { name, type: 'text', value: decimal === '' ? null : decimal } });
    };

    return (
        <>
            <div className={formStyles.preview_bandeira}>
                <h4>Dados do Poço</h4>
            </div>

            <div className={formStyles.row}>
                <Input
                    text="Identificação do Poço"
                    title="Nome ou código que identifica este poço nos documentos e nas medições. Exemplo: LRS01."
                    name="produtoBens.pocoIdentificacao"
                    placeholder="Ex.: POÇO01"
                    inputWidth="250px"
                    handleOnChange={change}
                    value={bem.pocoIdentificacao ?? ''}
                />
                <Input
                    text="Aquífero"
                    title="Nome do aquífero ou sistema aquífero de captação, conforme documento técnico ou outorga."
                    name="produtoBens.pocoAquifero"
                    inputWidth="350px"
                    handleOnChange={change}
                    value={bem.pocoAquifero ?? ''}
                />
            </div>

            <div className={formStyles.row}>
                {medidas.map(({ name, label, title }) => (
                    <TextField
                        key={name}
                        name={`produtoBens.${name}`}
                        label={label}
                        title={title}
                        value={bem[name] ?? ''}
                        onChange={changeMedida}
                        onBlur={(event) => {
                            const { name: field, value } = event.target;
                            if (value.endsWith('.')) {
                                change({ target: { name: field, type: 'text', value: value.slice(0, -1) } });
                            }
                        }}
                        type="text"
                        size="small"
                        inputProps={{ inputMode: 'decimal' }}
                        helperText="Até 3 casas decimais, sem separador de milhar."
                        sx={{ width: '260px', maxWidth: '100%', my: 1 }}
                    />
                ))}
            </div>

            <div className={formStyles.row}>
                <TextField
                    name="produtoBens.pocoObservacao"
                    label="Observações do Poço"
                    title="Informações técnicas e ressalvas sobre o cadastro do poço. As leituras e condicionantes possuem registros próprios."
                    value={bem.pocoObservacao ?? ''}
                    onChange={change}
                    multiline
                    minRows={3}
                    size="small"
                    fullWidth
                    sx={{ my: 1 }}
                />
            </div>
        </>
    );
};

export default PocoSection;
